import './styles/base.css';
import { RouterWrapper } from "./pages/index.jsx";
import { RouterProvider } from "react-router-dom";
import React from 'react';
import { useConfig } from './context/ConfigContext.js';
import { CategoriaProvider } from './components/CategoriaContext.jsx';
import Modal from 'react-modal';

function App({ logo }) {
  const { storeSettings } = useConfig();

  // Configurar react-modal para accesibilidad
  Modal.setAppElement('#root');

  return (
    <CategoriaProvider>
      {/* Ejemplo: mostrar el tipo de logo actual */}
      <div style={{ position: 'absolute', top: 0, right: 0, fontSize: 12, color: '#888' }}>
        Logo type: {storeSettings.logoType}
      </div>
      <RouterProvider router={RouterWrapper(logo)} />
    </CategoriaProvider>
  );
}

export default App; 